import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

import QuillEditorController from "./quill_editor_controller"
import PhoneInputController from "./phone_input_controller"
import VariantCbmController from "./variant_cbm_controller"
import SwiperSliderController from "./swiper_slider_controller"
import Select2Controller from "./select2_controller"
import DatatableController from "./datatable_controller"
import ConfirmModalController from "./confirm_modal_controller"
import LightboxGalleryController from "./lightbox_gallery_controller"
import DropzoneUploadController from "./dropzone_upload_controller"
import ConditionalFieldsController from "./conditional_fields_controller"
import RevenueChartController from "./revenue_chart_controller"
import RecaptchaController from "./recaptcha_controller"
import MetismenuController from "./metismenu_controller"
import AdminLayoutController from "./admin_layout_controller"
import ApexChartController from "./apex_chart_controller"

application.register("quill-editor", QuillEditorController)
application.register("phone-input", PhoneInputController)
application.register("variant-cbm", VariantCbmController)
application.register("swiper-slider", SwiperSliderController)
application.register("select2", Select2Controller)
application.register("datatable", DatatableController)
application.register("confirm-modal", ConfirmModalController)
application.register("lightbox-gallery", LightboxGalleryController)
application.register("dropzone-upload", DropzoneUploadController)
application.register("conditional-fields", ConditionalFieldsController)
application.register("revenue-chart", RevenueChartController)
application.register("recaptcha", RecaptchaController)
application.register("metismenu", MetismenuController)
application.register("admin-layout", AdminLayoutController)
application.register("apex-chart", ApexChartController)

export { application }
